import React from 'react';
import s from '../TierBadge.scss';
const Unlocked32 = ({ className  })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M15 0.57735C15.6188 0.220085 16.3812 0.220085 17 0.57735L28.8564 7.42265C29.4752 7.77992 29.8564 8.44017 29.8564 9.1547V22.8453C29.8564 23.5598 29.4752 24.2201 28.8564 24.5774L17 31.4226C16.3812 31.7799 15.6188 31.7799 15 31.4226L3.14359 24.5774C2.52479 24.2201 2.14359 23.5598 2.14359 22.8453V9.1547C2.14359 8.44017 2.52479 7.77992 3.14359 7.42265L15 0.57735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.1",
        d: "M15 3.57735C15.6188 3.22008 16.3812 3.22008 17 3.57735L26.2583 8.92265C26.8771 9.27992 27.2583 9.94017 27.2583 10.6547V21.3453C27.2583 22.0598 26.8771 22.7201 26.2583 23.0774L17 28.4226C16.3812 28.7799 15.6188 28.7799 15 28.4226L5.74167 23.0774C5.12287 22.7201 4.74167 22.0598 4.74167 21.3453V10.6547C4.74167 9.94017 5.12287 9.27992 5.74167 8.92265L15 3.57735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 6.57735C15.6188 6.22008 16.3812 6.22008 17 6.57735L23.6603 10.4226C24.2791 10.7799 24.6603 11.4402 24.6603 12.1547V19.8453C24.6603 20.5598 24.2791 21.2201 23.6603 21.5774L17 25.4226C16.3812 25.7799 15.6188 25.7799 15 25.4226L8.33975 21.5774C7.72094 21.2201 7.33975 20.5598 7.33975 19.8453V12.1547C7.33975 11.4402 7.72094 10.7799 8.33975 10.4226L15 6.57735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M21 13.5L19.8893 20.1644C19.8089 20.6466 19.3917 21 18.9029 21H13.0971C12.6083 21 12.1911 20.6466 12.1107 20.1644L11 13.5L14.125 15.375L16 11L17.875 15.375L21 13.5Z",
        className: s['bg-color']
    }));
Unlocked32.displayName = 'Unlocked32';
export default Unlocked32;
